import { useGetFastVarsQuery } from "@api/fast-versioning";
import type { IFsVariable } from "@/shared/types";
import { useMemo } from "react";

/**
 * Names of the org's user-created `date` variables. They are not in the
 * built-in date registries, so `isDateVariableName` needs them passed in to
 * treat `{{contract_start}}` as a date (calendar popover, offset/format
 * rendering) rather than plain text. Reads the fast-vars query cache only —
 * cheap enough for every inactive text element on the canvas.
 */
export const useCustomDateNames = (): ReadonlySet<string> => {
  const { data } = useGetFastVarsQuery(undefined);
  return useMemo(
    () =>
      new Set(
        ((data ?? []) as IFsVariable[]).flatMap((entry) =>
          entry?.variable?.type === "date" && entry.variable.name
            ? [entry.variable.name]
            : [],
        ),
      ),
    [data],
  );
};
